module.exports = __webpack_public_path__ + "img/xiaomi_logo.16669a79.png";